import React, { useState, useEffect } from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import Header from '../components/Header';
    import Footer from '../components/Footer';
    import ContentCard from '../components/ContentCard';
    import { supabase } from '../config/supabase';
    import { useAuth } from '../context/AuthContext';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiLock } = FiIcons;

    const EventsPage = () => {
      const { user, loading: authLoading } = useAuth();
      const [events, setEvents] = useState([]);
      const [loading, setLoading] = useState(true);

      useEffect(() => {
        if (user) {
          fetchEvents();
        } else {
          setLoading(false);
        }
      }, [user]);

      const fetchEvents = async () => {
        try {
          const { data, error } = await supabase
            .from('events')
            .select('*,profiles(name,instagram_handle)')
            .eq('status', 'approved')
            .order('start_datetime', { ascending: true });
          if (error) throw error;
          const upcomingEvents = data.filter(event => !event.end_datetime || new Date(event.end_datetime) > new Date());
          setEvents(upcomingEvents);
        } catch (error) {
          console.error('Error fetching events:', error);
        } finally {
          setLoading(false);
        }
      };

      if (loading || authLoading) {
        return (
          <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-yellow-500"></div>
          </div>
        );
      }

      return (
        <div className="min-h-screen bg-white">
          <Header />
          <main className="container mx-auto px-4 py-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-12"
            >
              <h1 className="text-5xl font-bold text-gray-900 mb-4">Upcoming Events</h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Discover events hosted by Chaldean creators and businesses.
              </p>
            </motion.div>

            {!user ? (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-center py-16 bg-slate-50 rounded-lg border border-slate-200"
              >
                <div className="mx-auto w-16 h-16 bg-slate-200 rounded-full flex items-center justify-center mb-4">
                  <SafeIcon icon={FiLock} className="text-3xl text-slate-500" />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-2">Access Restricted</h3>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">This content is for members only. Please sign up or log in to view upcoming events.</p>
                <div className="flex justify-center space-x-4">
                  <Link to="/login" className="bg-slate-900 text-white px-6 py-2.5 rounded-lg hover:bg-slate-800 transition-colors font-semibold">
                    Login
                  </Link>
                  <Link to="/signup" className="bg-yellow-500 text-white px-6 py-2.5 rounded-lg hover:bg-yellow-600 transition-colors font-semibold">
                    Sign Up
                  </Link>
                </div>
              </motion.div>
            ) : events.length === 0 ? (
              <div className="text-center py-16">
                <h3 className="text-2xl font-semibold text-gray-900 mb-2">No events found</h3>
                <p className="text-gray-600">There are currently no upcoming events.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {events.map(event => (
                  <ContentCard key={event.id} item={event} type="event" />
                ))}
              </div>
            )}
          </main>
          <Footer />
        </div>
      );
    };

    export default EventsPage;